import React, { useEffect, useState } from "react";
import styles from "./ToolbarManager.module.css";
import { SearchBar } from "components/forms";
import { useDispatch, useSelector } from "react-redux";
import { setManagerSearch } from "store/searchbar/searchbarSlice";

const ToolbarManager = ({type, data}) => {

  const searchData = useSelector( (state) => state.searchbar.manager);
  const dispatch = useDispatch();
  
  const onChanged = (key, value) => {
    dispatch(setManagerSearch({active: type, key, value}));
  };

  const renderToolbar = () => {
    
    if(!data) {
      return null;
    }
    
    if(searchData[type]) {
      return <SearchBar
                  onSearchChanged={onChanged} 
                  data={{filter: data.filter, sort: data.sort, current: searchData[type]}}
              />;
    }

    return null;
  };

  return (
    <>
    { renderToolbar() }
    </>
  );
};

export default ToolbarManager;